export default __webpack_public_path__ + "static/app2-9c9875792d8cdac06450efe947ae93d1.jpg";